import script from "./section3.vue?vue&type=script&setup=true&lang=js"
export * from "./section3.vue?vue&type=script&setup=true&lang=js"

import "./section3.vue?vue&type=style&index=0&id=dc9686c0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc9686c0"]])

export default __exports__